<template>
    <div class="newsletter">
        <template v-if="settings && settings.Title">
            <div class="newsletter__subtitle mb-2">{{ settings.Subtitle }}</div>
            <div class="newsletter__title main-title">{{ settings.Title }}</div>
            <div class="newsletter__text text mb-5">{{ settings.Text }}</div>
        </template>

        <template v-if="!isSuccess">
            <div v-if="isError" class="alert alert-danger mb-2" role="alert">Popraw błędy w formularzu!</div>
            <div class="newsletter__input-group position-relative mb-5">
                <div class="newsletter__input-group-text">
                    <i class="material-icons">edit</i>
                </div>
                <input
                    v-model="email"
                    :disabled="isLoading"
                    type="text"
                    class="form-control newsletter__form-control"
                    :class="{'is-invalid': $v.email.$dirty && $v.email.$invalid}"
                    placeholder="Wpisz swój e-mail"
                    @blur="$v.email.$touch()"
                />
                <div class="invalid-feedback">Podaj prawidłowy adres email.</div>
            </div>
            <div class="wbutton wbutton--secondary d-inline-flex align-items-center justify-content-center" style="min-width: 200px" @click="signUp">
                <span v-if="isLoading" class="spinner-grow spinner-grow-sm mr-2" role="status" aria-hidden="true"></span>
                {{ isLoading ? 'zapisuję...' : 'wyślij' }}
            </div>
        </template>
        <div v-else class="alert alert-primary" role="alert">Zostałeś zapisany/a do newslettera!</div>
    </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
    name: "Newsletter",
    props: ["settings"],
    data() {
        return {
            email: undefined,
            isLoading: false,
            isSuccess: false,
            isError: false
        };
    },
    validations: {
        email: {
            required,
            email
        }
    },
    methods: {
        async signUp() {
            if (!this.isLoading) {
                this.isLoading = true;
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    try {
                        let { data } = await this.$http.post("/subscribe", {
                            email: this.email
                        });
                        this.isSuccess = data.success;
                        this.isError = !data.success;
                    } catch (error) {
                        console.log(error);
                    }
                }
                this.isLoading = false;
            }
        },
        validate() {}
    }
};
</script>

<style>
</style>